var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['j-gis-map-layout', _vm.currentMeasureType]},[_c('div',_vm._b({staticClass:"j-gis-map",attrs:{"id":_vm.mapRandomId}},'div',_vm.$attrs,false)),(_vm.showCoordinate)?_c('j-gis-coord',{attrs:{"point":_vm.coordinateTarget}}):_vm._e(),_vm._t("control"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }